import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomerSSidebar from "./components/CustomerSSidebar";
import Header from "../../component/Header";

const apiUrl = process.env.REACT_APP_API_URL;

function CustomSummary() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const sortByOrderNumber = (data) => {
    return data
      .filter(
        (item) => item.ourStat === "Unpaid" || item.ourStat === "Received"
      )
      .sort((a, b) => {
        // First sort by ourStat
        const statusCompare = a.ourStat.localeCompare(b.ourStat);
        if (statusCompare !== 0) return statusCompare;

        // Then sort by buyer name if ourStat is the same
        return (a.buyer || "").localeCompare(b.buyer || "");
      });
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/items`);
      const fetchedData = response.data.map((item) => ({
        ...item,
        imageUrl1: `${apiUrl}/uploads/${item.ImageFilename1}`, // Construct the first image URL
        imageUrl2: `${apiUrl}/uploads/${item.ImageFilename2}`, // Construct the image URL
      }));
      const sortedData = sortByOrderNumber(fetchedData);

      setData(sortedData); // Set the sorted data
      setFilteredData(sortedData); // Initialize filteredData with all products
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    fetchData();
    total();
  }, []);

  const total = () => {
    let sum = 0;

    data.forEach((item) => {
      const price = Number(item.Price) || 0;
      const com1 = Number(item.com1) || 0;
      const com2 = Number(item.com2) || 0;
      const deliveryFee = Number(item.DeliveryFee) || 0;

      sum += price + com1 + com2 + deliveryFee;
    });

    return sum;
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`; // Format as 'YYYY-MM-DD'
  };
  const unpaidItems = filteredData.filter((item) => item.ourStat === "Unpaid");
  const receivedItems = filteredData.filter(
    (item) => item.ourStat === "Received"
  );

  return (
    <>
      <Header />
      <CustomerSSidebar />
      <div className="items-center flex flex-col justify-center mt-1 overflow-auto">
        {/* ===== UNPAID TABLE ===== */}
        <div className="border border-red-500 mt-20 w-3/4 mb-10 p-5 rounded-md overflow-auto">
          <h1 className="font-bold text-2xl text-red-700 mb-5">Unpaid Items</h1>
          <table className="border-collapse table-auto w-full mb-5">
            <thead>
              <tr>
                <th className="bg-red-100 border-b-1">#</th>
                <th className="bg-red-200 border-b-1">Brand</th>
                <th className="bg-red-100 border-b-1">Model</th>
                <th className="bg-red-200 border-b-1">Storage</th>
                <th className="bg-red-100 border-b-1">Ram</th>
                <th className="bg-red-200 border-b-1">Sim</th>
                <th className="bg-red-100 border-b-1">Buyer</th>
                <th className="bg-red-200 border-b-1">Sold Price</th>
                <th className="bg-red-100 border-b-1">Date</th>
                <th className="bg-red-200 border-b-1">Status</th>
              </tr>
            </thead>
            <tbody>
              {unpaidItems.map((item, index) => (
                <tr key={index}>
                  <td className="bg-red-50 border-b-1">{item.OrderNumber}</td>
                  <td className="bg-red-100 border-b-1">{item.Brand}</td>
                  <td className="bg-red-50 border-b-1">{item.Model}</td>
                  <td className="bg-red-100 border-b-1">{item.Storage}</td>
                  <td className="bg-red-50 border-b-1">{item.Ram}</td>
                  <td className="bg-red-100 border-b-1">{item.Sim}</td>
                  <td className="bg-red-50 border-b-1">{item.buyer}</td>
                  <td className="bg-red-100 border-b-1">{item.soldPrice}</td>
                  <td className="bg-red-50 border-b-1">
                    {formatDate(item.salesDate)}
                  </td>
                  <td className="bg-red-100 border-b-1">{item.ourStat}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-lg font-bold mt-2">
            Total Unpaid: {unpaidItems.length}
          </p>
        </div>

        {/* ===== RECEIVED TABLE ===== */}
        <div className="border border-green-500 w-3/4 mb-20 p-5 rounded-md overflow-auto">
          <h1 className="font-bold text-2xl text-green-700 mb-5">
            Received Items
          </h1>
          <table className="border-collapse table-auto w-full mb-5">
            <thead>
              <tr>
                <th className="bg-green-100 border-b-1">#</th>
                <th className="bg-green-200 border-b-1">Brand</th>
                <th className="bg-green-100 border-b-1">Model</th>
                <th className="bg-green-200 border-b-1">Storage</th>
                <th className="bg-green-100 border-b-1">Ram</th>
                <th className="bg-green-200 border-b-1">Sim</th>
                <th className="bg-green-100 border-b-1">Buyer</th>
                <th className="bg-green-200 border-b-1">Sold Price</th>
                <th className="bg-green-100 border-b-1">Date</th>
                <th className="bg-green-200 border-b-1">Status</th>
              </tr>
            </thead>
            <tbody>
              {receivedItems.map((item, index) => (
                <tr key={index}>
                  <td className="bg-green-50 border-b-1">{item.OrderNumber}</td>
                  <td className="bg-green-100 border-b-1">{item.Brand}</td>
                  <td className="bg-green-50 border-b-1">{item.Model}</td>
                  <td className="bg-green-100 border-b-1">{item.Storage}</td>
                  <td className="bg-green-50 border-b-1">{item.Ram}</td>
                  <td className="bg-green-100 border-b-1">{item.Sim}</td>
                  <td className="bg-green-50 border-b-1">{item.buyer}</td>
                  <td className="bg-green-100 border-b-1">{item.soldPrice}</td>
                  <td className="bg-green-50 border-b-1">
                    {formatDate(item.salesDate)}
                  </td>
                  <td className="bg-green-100 border-b-1">{item.ourStat}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-lg font-bold mt-2">
            Total Received: {receivedItems.length}
          </p>
        </div>
      </div>
    </>
  );
}

export default CustomSummary;
